import React, { useState, useEffect } from 'react';
import './EqSchoolStudentsBoard.scss';
import { paymentStatusType, EqLocationType } from '../../shared/enums';
import { Row, Col } from 'antd';
import { Input } from 'antd';
import EqSelect from '../../custom/eqSelect/EqSelect';
import EqButton from '../../custom/eqButton/EqButton';
import { useTranslation } from 'react-i18next';
import Api from '../../shared/Api';
import { EqStatusCode, GetInvitesMessage, ApiEndpoints } from '../../shared/Common';
import { ISelectOption, ISelectProps } from '../../shared/Interfaces';
import EqInviteToJoin, { IEqInviteToJoin } from '../../custom/eqInviteToJoin/EqInviteToJoin';
import EqSentInvitesList, { IEqSentInvitesList } from '../../eqTrainer/eqSentInvitesList/EqSentInvitesList';
import EqStudentList, { IEqStudentList } from '../../eqTrainer/eqStudentList/EqStudentList';
import AnimationDiv from '../../custom/animationDiv/AnimationDiv';
import { EqUiUser, EqUserInfoDto } from '../../shared/interfaces/IUserInfoDto';
import { EqUiStudentGroup } from '../../shared/interfaces/IUserGroupDto';
import { CurrentStudentItem, InvitationItem, RequestItem } from '../../shared/Invites/IStudentInvites';



interface CurrentStudentsList {
    allStudents: CurrentStudentItem[];
    filteredStudents: CurrentStudentItem[];
}
interface SelectedRequest {
    Key: string;
}

interface SelectedInvite {
    Key: number | null | undefined;
    Email: string | undefined;
}
const EqSchoolStudentsBoard = () => {
    const { t, i18n } = useTranslation();
    const { Search } = Input;
    const [addNew, setAddNew] = useState(false);
    const [inisCheckAll, insetIsCheckAll] = useState(false);
    const [requestslist, setrequestsList] = useState<RequestItem[]>([]);
    const [invitesList, setInvitesList] = useState<InvitationItem[]>([]);

   
    const [currentStudentslist, setCurrentStudentsList] = useState<CurrentStudentsList>({
        allStudents: [],
        filteredStudents: []
    });
    const [messageString, setMessageString] = useState<string>('');
    const [searchStr, setSearchStr] = useState<string>("");
    const [requestKeys, setRequestKeys] = useState<SelectedRequest[]>([]);
    const [inviteKeys, setInviteKeys] = useState<SelectedInvite[]>([]);
    const [paymentStatus, setPaymentStatus] = useState<ISelectOption[]>();
    const [search, setSearch] = useState<{ searchVal: string; paymentFilter: number[] }>({ 
        searchVal: '', 
        paymentFilter: [] 
    });

    const selectedRequests: SelectedRequest[] = [];
    const selectedInvites: SelectedInvite[] = [];


    const getPaymentStatusClass = (status: paymentStatusType): string => {
        if (status == paymentStatusType.Paid) return "green";
        else if (status == paymentStatusType.UnpaidButAttending) return "red";
        else if (status == paymentStatusType.StudentCancelled) return "purple";
        else return "orange";
    };
 

    const createPaymentStatusTypes = () => {
        const types: ISelectOption[] = [];
    
        // Get the numeric enum values
        (Object.keys(paymentStatusType) as Array<keyof typeof paymentStatusType>)
        .filter(key => isNaN(Number(key))) // Filter out numeric keys (reverse mapping)
        .forEach(key => {
            const value = paymentStatusType[key];
            types.push({
                key: value.toString(),
                value: getPaymentStatusClass(value),
                label: key
            });
        });
    
        setPaymentStatus(types);
    };
  const onRequestCheckChange = (data: RequestItem, checked: boolean) => {
        if (checked && data.request.key) {
            selectedRequests.push({ Key: data.request.key });
        } else {
            if (selectedRequests.length > 0 && data.request.key) {
                const index = selectedRequests.findIndex(x => x.Key == data.request.key);
                if (index > -1) {
                    selectedRequests.splice(index, 1);
                }
            }
        }
        setRequestKeys([...selectedRequests]);
    };
 
    const invitesCheckAll = (list: InvitationItem[], checked: boolean) => {
        insetIsCheckAll(!inisCheckAll);

        list.forEach((m) => {
            if (m.selected == false) {
                m.selected = !checked;
                if (m.student.key && m.student.email) {
                    selectedInvites.push({ Key: m.student.key, Email: m.student.email });
                }
            } else {
                m.selected = !checked;
                if (selectedInvites.length > 0 && m.student.key) {
                    const index = selectedInvites.findIndex(x => x.Key == m.student.key);
                    if (index > -1) {
                        selectedInvites.splice(index, 1);
                    }
                }
            }
        });
        setInviteKeys([...selectedInvites]);
        const modifiedList = [...list];
        setInvitesList(modifiedList);
    };
    const onInviteCheckChange = (data: InvitationItem, checked: boolean) => {

        if (checked) {
            selectedInvites.push({ Key: data.student.key, Email: data.student.email });
        }
        else {
            if (selectedInvites != null && selectedInvites.length > 0) {
                const index = selectedInvites.findIndex(x => x.Key == data.student.key);
                if (index > -1) {
                    selectedInvites.splice(index, 1);
                }
            }
        }
        console.log(selectedInvites);
        setInviteKeys(selectedInvites);
    }
    const deleteSelectedInvitation = () => {
        //console.log(inviteKeys);

        insetIsCheckAll(false);
        if (inviteKeys.length > 0) {

            Api.post(ApiEndpoints.SchoolStudentDeleteSelectedInvitation, inviteKeys).then(response => {
                if (response && response.status == 200) {
                    GetInvitations();
                    setMessageString('success');
                } else {
                    setMessageString('failed');
                }
            }, err => {
                setMessageString('failed');
            });
        }
    }
    const showAddNew = () => {
        setAddNew(true);
    }
    const cancelFunction = () => {
        setAddNew(false);
    }
    const SendInviteClicked = (success: boolean) => {
        if (success == true) {
            GetInvitations();
        }
    }
    
    const onSortChange = (event: "Sort A-Z" | "Sort Z-A") => {
        let sortedList: CurrentStudentItem[];
        switch (event) {
            case "Sort A-Z":
                sortedList = [...currentStudentslist.filteredStudents].sort((obj1, obj2) => {
                    if ((obj1.student.userName ?? "").toLowerCase() > (obj2.student.userName ?? "").toLowerCase()) { return 1; }
                    else if ((obj1.student.userName ?? "").toLowerCase() < (obj2.student.userName ?? "").toLowerCase()) { return -1 } else { return 0 }
                });
                setCurrentStudentsList({ ...currentStudentslist, filteredStudents: sortedList });
                break;
            case "Sort Z-A":
                sortedList = [...currentStudentslist.filteredStudents].sort((obj1, obj2) => {
                    if ((obj1.student.userName ?? "").toLowerCase() < (obj2.student.userName ?? "").toLowerCase()) { return 1; }
                    else if ((obj1.student.userName ?? "").toLowerCase() > (obj2.student.userName ?? "").toLowerCase()) { return -1 } else { return 0 }
                });
                setCurrentStudentsList({ ...currentStudentslist, filteredStudents: sortedList });
                break;
        }
    };

    const onRequestsSortChange = (event: "Sort A-Z" | "Sort Z-A") => {
        let sortedList: RequestItem[];
        switch (event) {
            case "Sort A-Z":
                sortedList = [...requestslist].sort((obj1, obj2) => {
                    if ((obj1.request.userName ?? "").toLowerCase() > (obj2.request.userName ?? "").toLowerCase()) { return 1; }
                    else if ((obj1.request.userName ?? "").toLowerCase() < (obj2.request.userName ?? "").toLowerCase()) { return -1 } else { return 0 }
                });
                setrequestsList(sortedList);
                break;
            case "Sort Z-A":
                sortedList = [...requestslist].sort((obj1, obj2) => {
                    if ((obj1.request.userName ?? "").toLowerCase() < (obj2.request.userName ?? "").toLowerCase()) { return 1; }
                    else if ((obj1.request.userName ?? "").toLowerCase() > (obj2.request.userName ?? "").toLowerCase()) { return -1 } else { return 0 }
                });
                setrequestsList(sortedList);
                break;
        }
    };

    const onInvitesSortChange = (event: "Sort A-Z" | "Sort Z-A") => {
        let sortedList: InvitationItem[];
        switch (event) {
            case "Sort A-Z":
                sortedList = [...invitesList].sort((obj1, obj2) => {
                    if ((obj1.student.userName ?? "").toLowerCase() > (obj2.student.userName ?? "").toLowerCase()) { return 1; }
                    else if ((obj1.student.userName ?? "").toLowerCase() < (obj2.student.userName ?? "").toLowerCase()) { return -1 } else { return 0 }
                });
                setInvitesList(sortedList);
                break;
            case "Sort Z-A":
                sortedList = [...invitesList].sort((obj1, obj2) => {
                    if ((obj1.student.userName ?? "").toLowerCase() < (obj2.student.userName ?? "").toLowerCase()) { return 1; }
                    else if ((obj1.student.userName ?? "").toLowerCase() > (obj2.student.userName ?? "").toLowerCase()) { return -1 } else { return 0 }
                });
                setInvitesList(sortedList);
                break;
        }
    };



    const acceptJoiningRequest = (student: { key?: string }): Promise<boolean> => {
        return Api.post(ApiEndpoints.acceptJoiningRequest, student).then(response => {
            if (response && response.status == 200) {
                GetPendingRequests();
                GetCurrentStudents();
                return true;
            } else {
                return false;
            }
        }, err => {
            return false;
        });
    };



     const deleteInvitation = (student: { email?: string }): Promise<boolean> => {
        return Api.post(ApiEndpoints.SchoolStudentDeleteInvitation, student).then(response => {
            if (response && response.status == 200) {
                GetInvitations();
                return true;
            } else {
                return false;
            }
        }, err => {
            return false;
        });
    };
    const deleteRequest = (student: { key?: string }): Promise<boolean> => {
        setrequestsList([]);
        return Api.post(ApiEndpoints.deleteRequest, student).then(response => {
            if (response && response.status == 200) {
                GetPendingRequests();
                return true;
            } else {
                return false;
            }
        }, err => {
            return false;
        });
    };
    const deleteStudent = (student: { key?: string }): Promise<boolean> => {
        return Api.post(ApiEndpoints.SchoolDeleteStudent, student).then(response => {
            if (response && response.status == 200) {
                GetCurrentStudents();
                return true;
            } else {
                return false;
            }
        }, err => {
            return false;
        });
    };

    const GetInvitations = () => {
        Api.get(ApiEndpoints.SchoolGetSentInvites).then(response => {
            const students: InvitationItem[] = [];

            if (response && response.status == 200) {
                const invitedStudents: EqUiUser[] = response.data?.result ? [...response.data.result] : [];
                invitedStudents.forEach((d) => {
                    students.push({
                        student: {
                            key: d?.key,
                            firstName: d.firstName,
                            lastName: d?.lastName,
                            userName: d?.userName,
                            email: d.email,
                            locations: d.locations?.filter((opt) => (opt.location?.type == EqLocationType.Home)).shift(),
                            payment: d.paymentStatus,
                            groups: d.groups,
                            selected: false
                        },
                        deleteFunc: deleteInvitation,
                        checkChangeFunc: onInviteCheckChange,
                        selected: false
                    });
                });
                setInvitesList(students);
            } else {
                setMessageString(GetInvitesMessage(EqStatusCode.serverException502));
            }
        }, err => {
            setMessageString(GetInvitesMessage(err.response.status));
        });
    };


    const GetPendingRequests = () => {
    
        Api.get(ApiEndpoints.getRequests).then(response => {
            var requests:RequestItem [] = [];
            if (response && response.status == 200) {

                var pendingRequests:EqUiStudentGroup[] = response.data ? [...response.data] : [];
                
                pendingRequests.map((d) => {
                    //console.log(d);
                    requests.push({
                        request: {
                            key: d.user?.key,
                            firstName: d.user?.firstName,
                            lastName: d.user?.lastName,
                            userName: d.user?.userName,
                            email: d.user?.email,
                            locations: d.user?.locations?.filter((opt) => (opt.location?.type == EqLocationType.Home)).shift(),
                            // payment: d.user?.paymentStatus,
                            groups: d.user?.groups,
                            selected: false
                        },
                        deleteFunc: deleteRequest,
                        acceptFunc: acceptJoiningRequest,
                        checkChangeFunc: onRequestCheckChange,
                        selected: false
                    }as RequestItem )
                });
                setrequestsList(requests);
            } else {
                setMessageString("Not found");
            }
        }, err => {
            setMessageString("Not found");
        });
    }
    const GetCurrentStudents = () => {
        var students:CurrentStudentItem[] = [];
        Api.get(ApiEndpoints.SchoolStudents.GetCurrentStudents).then(response => {

            if (response && response.status == 200) {
                var data:EqUserInfoDto[] = response.data ? [...response.data] : [];
                data.map((d) => {
                    students.push({
                        student: {
                            firstName: d?.firstName,
                            lastName: d?.lastName,
                            userName: d?.userName,
                            phoneNumber: d?.phoneNumber,
                            email: d?.email,
                            payment: d?.paymentStatus,
                            groups: d?.groups,
                            selected: false
                        },
                        deleteFunc: deleteStudent,
                        selected: false
                    }
                    )
                });
                setCurrentStudentsList({ allStudents: [...students], filteredStudents: [...students] });
            } else {
                setMessageString("Not found");
            }
        }, err => {
            setMessageString("Not found");
        });
    }
    const searchClick = (searchStr: string) => {
        setSearch({ ...search, searchVal: searchStr })
        filterStudents(searchStr, search.paymentFilter);
    }

    const filterStudents = (searchFilter: string, paymentFilter: number[]) => {
        let filterResult = currentStudentslist.allStudents;
        if (searchFilter) {
            filterResult = filterResult.filter((g) => {
                return g.student.userName?.includes(searchStr) ?? false;
            });
        }
        if (paymentFilter.length > 0) {
            filterResult = filterResult.filter((g) => {
                return paymentFilter.some((status) => {
                    return status == g.student.payment;
                });
            });
        }
        setCurrentStudentsList({ ...currentStudentslist, filteredStudents: filterResult });
    };
    const studentInviteProps: IEqInviteToJoin = {
        header: t("inviteStudent"), 
        emailHeading: t("pleaseAddYourStudentEmail"), 
        messageHeading: t("message"),
        cancelFunc: cancelFunction, 
        sendFunc: SendInviteClicked
    };

    const filterProps: ISelectProps = {
        mode: "multiple",
        classNames: "eq-multiSelect",
        border: false,
        dropdownClassName: 'eq-select-dropdown',
        isTag: true,
        ddClassName: "eq-select-dropdown",
        icon: [<span className="eq-fb-filter"><img alt="" src="/Filter.svg" /></span>],
        selectedIcon: [<span className="eq-fb-filter"><img alt="" src="/check-square.svg" /></span>],
        options: paymentStatus,
        changeFunc: (value: number[]) => {
            setSearch({ ...search, paymentFilter: value });
            filterStudents(search.searchVal, value);
        }
    };
    const invitesSortProps: ISelectProps = {
        border: false, 
        allowClear: false, 
        classNames: "eq-select-sort", 
        defaultSelectedValue: "Sort A-Z", 
        changeFunc: onInvitesSortChange,
        options: [{ key: "Sort A-Z", value: "Sort A-Z" }, { key: "Sort Z-A", value: "Sort Z-A" }]
    };

    const requestsSortProps: ISelectProps = {
        border: false, 
        allowClear: false, 
        classNames: "eq-select-sort", 
        defaultSelectedValue: "Sort A-Z", 
        changeFunc: onRequestsSortChange,
        options: [{ key: "Sort A-Z", value: "Sort A-Z" }, { key: "Sort Z-A", value: "Sort Z-A" }]
    };

    const studentSortProps: ISelectProps = {
        border: false, 
        allowClear: false, 
        classNames: "eq-select-sort", 
        defaultSelectedValue: "Sort A-Z", 
        changeFunc: onSortChange,
        options: [{ key: "Sort A-Z", value: "Sort A-Z" }, { key: "Sort Z-A", value: "Sort Z-A" }]
    };

    const studentsList: IEqStudentList = { 
        studentsList: currentStudentslist.filteredStudents 
    };

    const sentInvitesList: IEqSentInvitesList = { 
        sentInvitesList: invitesList, 
        checkAllFun: invitesCheckAll, 
        checkAll: inisCheckAll 
    };
     useEffect(() => {
        GetInvitations();
        GetCurrentStudents();
        createPaymentStatusTypes();
    }, []);
    return (
        <>

            <AnimationDiv>

                <div className="eq-sb-container">
                    <Row className="eq-sb-heading-row">
                        <Col className="eq-sb-col" flex="auto" sm={5} xs={4}>
                            <h2 className="eq-sb-heading">{t("students")}</h2>
                        </Col>
                        <Col className="eq-sb-col" flex="auto" sm={19} xs={20}>
                            <Row className="eq-sb-student-header" justify="end" align="bottom">
                                <Col className="eq-sb-followers hidden-sm">
                                    {t("followers")} {currentStudentslist.allStudents?.length}
                                </Col>
                                <Col className="eq-sb-student-sort hidden-sm">
                                    <EqSelect key={1}  {...studentSortProps} ></EqSelect>
                                </Col>
                                <Col className="eq-sb-student-search" xs={14} sm={14} md={6} lg={6} xl={6} xxl={6}>
                                    <Search placeholder={t("inputSearchText")} onChange={(e) => setSearchStr(e.target.value)} onSearch={searchClick} />
                                </Col>
                                <Col>

                                </Col>
                                <Col>
                                    <div className="eq-sb-student-btn" >
                                        <EqButton  onClick={showAddNew} classNames="btn-background-orange">
                                            <img alt="" src="/plus.svg" />
                                            <span className="hidden-sm"><span className="icon-space"></span>{t("addNew")}</span></EqButton>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    <div>
                        {addNew &&
                            <EqInviteToJoin {...studentInviteProps}></EqInviteToJoin>
                        }
                    </div>
                    <Row className="eq-sb-list-header" justify="center" align="middle">
                        <Col className="hidden-md" xs={24} sm={24}>
                            <div className="eq-sb-followers">
                                {t("followers")} {currentStudentslist.allStudents?.length}
                            </div>
                        </Col>
                        <Col className="hidden-md" xs={7} sm={6}>
                            <div className="eq-sb-student-sort">
                                <EqSelect key={2} {...studentSortProps} ></EqSelect>
                            </div>
                        </Col>
                        <Col xs={24} sm={24}>
                            <Row justify="center">

                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="eq-sb-select hidden-sm" span={24}>
                            <EqSelect key={3} {...filterProps}></EqSelect>
                        </Col>
                    </Row>
                    <div className="">
                        <EqStudentList {...studentsList}></EqStudentList>
                    </div>
                  

                    <Row className="eq-sb-heading-row">
                        <Col className="eq-sb-heading" flex="auto">
                            {t("sentInvites")}
                        </Col>
                        <Col className="eq-sb-col hidden-sm" flex="auto">
                            <Row className="eq-sb-student-header" justify="end" align="bottom">
                                <Col className="eq-sb-followers">
                                    {t("sentInvites")} {invitesList.length}
                                </Col>
                                <Col className="eq-sb-student-header-right">
                                    <div className="eq-sb-student-sort">
                                        <EqSelect key={6} {...invitesSortProps}></EqSelect>
                                    </div>
                                </Col>
                           
                                <Col>
                                    <div className="eq-sb-student-btn">
                                        <EqButton  bordered classNames="btn-border-orange" onClick={deleteSelectedInvitation}>
                                            <span className="eq-btn-icon"><img alt="" src="/text.svg" /></span>
                                            {t("clearInvites")}</EqButton>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="eq-sb-list-header" justify="center" align="middle">
                        <Col className="hidden-md" xs={24} sm={24}>
                            <div className="eq-sb-followers">
                                {t("sentInvites")} {invitesList.length}
                            </div>
                        </Col>
                        <Col className="hidden-md" xs={7} sm={6}>
                            <div className="eq-sb-student-sort">
                                <EqSelect key={7} {...invitesSortProps} ></EqSelect>
                            </div>
                        </Col>
                        <Col xs={24} sm={24}>
                            <Row justify="center">
                           
                                <Col >
                                    <div className="eq-sb-student-btn hidden-md" onClick={deleteSelectedInvitation}>
                                        <EqButton  bordered classNames="btn-border-orange">
                                            <img alt="" src="/text.svg" /><span className="icon-space"></span>
                                            {t("clearInvites")}</EqButton>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    <div className="">
                        <EqSentInvitesList {...sentInvitesList}></EqSentInvitesList>
                    </div>
                </div>

            </AnimationDiv>
        </>
    );
}
export default EqSchoolStudentsBoard;